import { Container, Stack } from '@optimus-web/core';

export const PaymentMethodStatusHistoryBodyWrapper = ({ children }: { children: React.ReactNode }) => (
    <Container padding={['100', '0']}>
        <Stack vertical spacing="50">
            {children}
        </Stack>
    </Container>
);
